<template>
  <div class="index">
    <div class="centered">
      <span class="button-wrapper add-redirect" @click="addNewRedirect">
        <a class="button is-info">+</a>Создать редирект
      </span>
    </div>
    <div class="redirects">
      <RedirectItem v-for="redirect in redirectsData"
      :key="redirect.id"
      :redirect="redirect"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RedirectItem from 'components/Redirects/RedirectItem'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Redirects',
  data () {
    return {
      newRedirects: []
    }
  },
  computed: {
    ...mapState(['redirects']),
    redirectsData () {
      return deepcopy(this.redirects)
    }
  },
  created () {
    this.getRedirects()
  },
  methods: {
    ...mapActions(['getRedirects', 'addRedirectSchema']),
    addNewRedirect () {
      this.addRedirectSchema({
        isNew: true,
        fromUrl: '',
        toUrl: '',
        tempId: uuidv4()
      })
    }
  },
  components: { RedirectItem }
}
</script>

<style scoped>
.add-redirect {
  margin-top: 40px;
}
.redirects {
  max-width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Index.vue?221af192